<template>
  <bonus-dialog>
    <template v-slot:title>看视频送现金 看越久送越多</template>
    <div class="bonusDialogBreak_bouns">恭喜获得{{limitAmount === totalAmount ? `今日最高彩金`: '彩金'}}
      <span class="bonusDialogBreak_bouns_coin">&nbsp;¥&nbsp;{{ totalAmountFormat }}</span>
    </div>
    <div class="row">
      <div
        v-for="n of coinCount"
        :key="n"
        class="col-4 row q-my-sm justify-center items-start">
        <div
          class="bonusDialogBreak_amount"
          :class="{'bonusDialogBreak_amount-active': n <= doneCount}">
          <div class="bonusDialogBreak_amount_coin q-py-xs">
            <img
              src="../../../assets/images/xbb/bonus_coin_solid.png"
              alt="coin"
              class="bonusDialogBreak_amount_coin_icon">
          </div>
          <div class="bonusDialogBreak_amount_number">+{{ breakAmountFormat }}</div>
          <img
            v-if="n <= doneCount"
            src="../../../assets/images/xbb/bonus_get_icon.png"
            alt="done"
            class="bonusDialogBreak_amount_done">
        </div>
      </div>
    </div>
    <div
      class="bonusDialogBreak_btn"
      @click="$emit('handle-continue-watch', status)">继续看片</div>
  </bonus-dialog>
</template>

<script>
import BonusDialog from './BonusDialog'

export default {
  name: 'BonusDialogBreak',
  components: {
    BonusDialog
  },
  props: {
    limitAmount: {
      type: Number,
      default: 0
    },
    breakAmount: {
      type: Number,
      default: 0
    },
    totalAmount: {
      type: Number,
      default: 0
    },
    status: {
      type: String,
      default: 'BREAK'
    }
  },
  data () {
    return {

    }
  },
  computed: {
    breakAmountFormat () {
      return this.breakAmount.toFixed(2)
    },
    totalAmountFormat () {
      return this.totalAmount.toFixed(2)
    },
    coinCount () {
      if (this.breakAmount === 0) return 0
      return this.limitAmount / this.breakAmount
    },
    doneCount () {
      if (this.breakAmount === 0) return 0
      return Math.floor(this.totalAmount / this.breakAmount)
    }
  }
}
</script>

<style scoped>

.bonusDialogBreak_title {
  font-size: 18px;
  font-weight: 700;
  color: #bf8646;
}

.bonusDialogBreak_bouns {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #3f1000;
}

.bonusDialogBreak_bouns_coin {
  font-size: 22px;
  font-weight: 700;
  color: #ff8c21;
}

.bonusDialogBreak_amount {
  position: relative;
  width: 54px;
  overflow: hidden;
  border-radius: 5px;
}

.bonusDialogBreak_amount_coin {
  width: 100%;
  height: 100%;
  background-color: #fcf7e2;
}

.bonusDialogBreak_amount_number {
  font-size: 15px;
  color: #ff8400;
  background-color: #f5d992;
}

.bonusDialogBreak_amount_done {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40px;
  height: 40px;
  transform: translate(-50%, -50%);
}

.bonusDialogBreak_amount-active {
  opacity: 0.6;
}

.bonusDialogBreak_amount_coin_icon {
  width: 35px;
  height: 35px;
  vertical-align: top;
}

.bonusDialogBreak_btn {
  width: calc(100% - 50px);
  height: 40px;
  margin: 20px auto 0 auto;
  font-size: 15px;
  font-weight: 700;
  line-height: 40px;
  color: #f2f2f2;
  text-align: center;
  background-color: #5e626d;
  border: none;
  border-radius: 20px;
}

.col-4 {
  flex: 0 0 auto;
}

.row > .col-4 {
  width: 33.3333%;
  height: auto;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.q-my-sm {
  margin-top: 8px;
  margin-bottom: 8px;
}

.justify-center {
  justify-content: center;
}

.items-start {
  align-items: flex-start;
}

.q-py-xs {
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/xbb/components/BonusDialogBreak.vue